import React, { useState, useEffect } from 'react';
import { LiveProvider, LiveEditor, LivePreview } from 'react-live';
import theme from 'prism-react-renderer/themes/dracula';
import { ComponentLibraryStyledEditor, ComponentLibraryCodeOutputWrapper } from './style';
import { CopyCode } from "@rocketseat/gatsby-theme-docs/src/components/Code/styles";
import { copyToClipboard } from "@rocketseat/gatsby-theme-docs/src/util/copy-to-clipboard";
import '../../../styles/bootstrap-import.scss';

const LiveEditorComponent = ({ component }) => {
    const [copied, setCopied] = useState(false);
    const [currentCode, setCurrentCode] = useState(component);

    useEffect(() => {
        const wrappedComponent = `<React.Fragment>${component}</React.Fragment>`;
        setCurrentCode(wrappedComponent);
    }, [component]);

    const handleClick = () => {
        setCopied(true);
        const codeWithoutFragment = currentCode.replace(/<React.Fragment>|<\/React.Fragment>/g, '');
        copyToClipboard(codeWithoutFragment);

        setTimeout(() => {
            setCopied(false);
        }, 4000);
    };

    const handleCodeChange = (newCode) => {
        const wrappedCode = `<React.Fragment>${newCode}</React.Fragment>`;
        setCurrentCode(wrappedCode);
    };

    const customErrorMessage = (error) => {
        let message = error.message.replace(/<React.Fragment>|<\/React.Fragment>/g, '');
        if (message.includes('Unterminated JSX contents')) {
            message = message.replace('JSX', 'HTML');
        }
        return message;
    };

    return (
        <LiveProvider code={currentCode} theme={theme} language="html">
            <ComponentLibraryStyledEditor>
                <CopyCode onClick={handleClick} disabled={copied} hasTitle>
                    {copied ? 'Copied!' : 'Copy'}
                </CopyCode>
                <LiveEditor onChange={handleCodeChange}/>
            </ComponentLibraryStyledEditor>
            <ComponentLibraryCodeOutputWrapper>
                <LivePreview/>
            </ComponentLibraryCodeOutputWrapper>
        </LiveProvider>
    );
};

export default LiveEditorComponent;